import React,{Component} from 'react';
import {
  Card,
  CardBody
} from 'reactstrap';
import Icon from '../Icon';

class StatCard extends Component {

  render(){
    const {icon,value,unit,children,title} = this.props;

    return (
      <Card className='StatCard'>
        <CardBody>
          {icon && (
            <div className='stat-icon'>
              <Icon glyph={icon} size='32' color='#FF5728' />
            </div>
          )}



          {value && (
            <div className='stat-value'>
              {value}
              <span className='stat-unit'>
                {unit}
              </span>
            </div>
          )}

          {children && (
            <div className='stat-children'>
              {children}
            </div>
          )}


          {title && (
            <div className='stat-title'>
              {title}
            </div>
          )}

        </CardBody>
      </Card>
    )
  }
}

export default StatCard;



// WEBPACK FOOTER //
// ./src/shared/components/StatCard/StatCard.js